// @flow
import type { Node } from "react"
import type { Params } from "react-router"

type Routes = Array<{
  name?: string,
  path: string,
  component: Node,
}>

// eslint-disable-next-line import/prefer-default-export
export function updateRoute(params: Params, routes: Routes, query: { [string]: string }) {
  return {
    type: "UPDATE_ROUTE",
    params,
    pageName: routes[routes.length - 1].name,
    pageNamesPath: routes
      .map(route => route.name)
      .filter(Boolean)
      .join("/"),
    query,
  }
}
